<div
    [ngClass]="{ selected: selected?.ContractId === contract.ContractId }"
    (click)="selectContract(contract)"
    class="edp-card-contract card h-100"
>
    <div class="card-body d-flex">
        <div class="card-icon w-25 d-flex flex-column">
            <span class="icon-top">
                <i class="icon {{ type.iconBop }}" [ngClass]="{ disabled: contract.Status === ContractStatusEnum.INACTIVE }"  aria-hidden="true"></i>
            </span>
            <span *ngIf="contract.EmployeeBenefit" class="icon-bottom mb-4">
                <i class="icon-edponline-Bra-134"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="card-body-content w-75">
            <span class="d-flex justify-content-between">
                <span class="card-title" [title]="contract.Nickname">{{ contract.Nickname }}</span>
                <a class="d-block d-lg-none card-title-no-data" *ngIf="contract.Status === ContractStatusEnum.INACTIVE">
                    {{ "pt.edp.edponline.contract.inactive_place" | translate }}
                </a>
                <a class="d-block d-lg-none card-title-no-data" *ngIf="contract.Status !== ContractStatusEnum.INACTIVE && true">
                    {{ "pt.edp.edponline.dashboard.no_alerts" | translate }}
                </a>
                <a class="d-block d-lg-none card-title-alerts" *ngIf="false">
                    {{ "pt.edp.edponline.dashboard.alerts" | translate }}
                </a>
            </span>
            <span class="card-title-address">{{ fullAddress | titlecase }}</span>
            <span class="card-title-local" *ngIf="contract.IsManaged">
                <span *ngIf="!contract.IsManagedByMe">
                    {{ "pt.edp.edponline.contract.managedby" | translate }}
                    <b>{{ contract.IsManagedBy.firstName | titlecase }} {{ contract.IsManagedBy.lastName | titlecase }}</b>
                </span>
                <span *ngIf="contract.IsManagedByMe">
                    {{ "pt.edp.edponline.contract.managing" | translate }}
                    <b>{{ contract.CustomerFirstName | titlecase }} {{ contract.CustomerLastName | titlecase }}</b>
                </span>
            </span>
            <span class="card-title-packs mt-3">
                <span *ngIf="contract.HasPack" class="{{ contract.getPackProperties(contract.HasPack).classColor }}">
                    {{ contract.getPackProperties(contract.HasPack).name | translate  }}
                </span>
                <span *ngIf="!contract.HasPack">{{ "pt.edp.edponline.packs.no_pack" | translate  }}</span>
            </span>
        </div>
    </div>
    <div class="card-footer d-none d-lg-block">
        <ng-container *ngIf="contract.Status !== ContractStatusEnum.INACTIVE">
            <span class="card-title-no-local d-flex h-100 align-items-center justify-content-center">
                Sem alertas
            </span>
        </ng-container>
        <ng-container *ngIf="contract.Status !== ContractStatusEnum.INACTIVE && false">
            <span class="d-block card-title">{{ "pt.edp.edponline.dashboard.alerts" | translate }}</span>
            <ul class="list-group list-unstyled">
                <li>
                    <a class="d-flex justify-content-between align-items-center">
                        <span class="text-uppercase">FATURA A PAGAR</span>
                        <span><i class="icon-edponline-Bra-006 icon-2x"  aria-hidden="true"></i></span>
                    </a>
                </li>
                <li>
                    <a class="d-flex justify-content-between align-items-center">
                        <span class="text-uppercase">Envie a leitura até 22 Setembro</span>
                        <span><i class="icon-edponline-Bra-021 icon-2x"  aria-hidden="true"></i></span>
                    </a>
                </li>
            </ul>
        </ng-container>
        <ng-container *ngIf="contract.Status === ContractStatusEnum.INACTIVE">
            <span class="card-title-no-local d-flex h-100 align-items-center justify-content-center">
                {{ "pt.edp.edponline.contract.inactive_place" | translate  }}
            </span>
        </ng-container>
    </div>
</div>
